/**
 * Payments API Service: frontend client for /api/payment (Stripe Connect).
 *
 * Organizers connect Stripe to get paid; players pay through Stripe Checkout,
 * which this app opens by sending the browser to the returned url.
 */

import { apiClient } from './apiService';

const paymentService = {
  /** { enabled, livemode, publishableKey, currency, platformFee } */
  getConfig() {
    return apiClient.get('/payment/config').then((r) => r.data);
  },

  /** What the player pays for a price, in cents. */
  getQuote(priceCents) {
    return apiClient.get('/payment/quote', { params: { priceCents } }).then((r) => r.data.quote);
  },

  getConnectStatus() {
    return apiClient.get('/payment/connect/status').then((r) => r.data.account);
  },

  /** Stripe-hosted onboarding link for the signed-in organizer. */
  startOnboarding() {
    return apiClient.post('/payment/connect/onboard').then((r) => r.data.url);
  },

  /** Stripe Express dashboard link (balance, payouts). */
  openDashboard() {
    return apiClient.post('/payment/connect/dashboard').then((r) => r.data.url);
  },

  /** Sandbox only: pay a connected organizer by username. Returns { url, paymentId, breakdown }. */
  startTestCheckout({ recipientUsername, priceCents, description }) {
    return apiClient
      .post('/payment/checkout/test', { recipientUsername, priceCents, description })
      .then((r) => r.data);
  },

  listPayments() {
    return apiClient.get('/payment/payments').then((r) => r.data.payments);
  },

  /** Payer came back from Checkout without paying: close it. Returns { status }. */
  cancelPayment(id) {
    return apiClient.post(`/payment/payments/${id}/cancel`).then((r) => r.data);
  },

  /** Organizer refunds a paid payment in full. Returns { status, refundStatus }. */
  refundPayment(id) {
    return apiClient.post(`/payment/payments/${id}/refund`).then((r) => r.data);
  },

  getPayment(id) {
    return apiClient.get(`/payment/payments/${id}`).then((r) => r.data.payment);
  },
};

export default paymentService;
